import { render, staticRenderFns } from "./TabBasicData.vue?vue&type=template&id=94660246&scoped=true&"
import script from "./TabBasicData.vue?vue&type=script&lang=js&"
export * from "./TabBasicData.vue?vue&type=script&lang=js&"
import style0 from "./TabBasicData.vue?vue&type=style&index=0&id=94660246&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94660246",
  null
  
)

component.options.__file = "TabBasicData.vue"
export default component.exports